export { TabsPage as TabsAdvance } from './tabs/tabs';
export { LoginPage } from './login/page';
export { HomePage } from './home/home';
export { DetailAdvPage } from './detail_adv/page';
export { AdvEmployeePage } from './adv_employee/page';
export { ListEmployeePage } from './list_employee/page';
export { OrganizationPage } from './organization/page';
export { UserAdvPage } from './user_adv/page'; 
export { AboutPage as AboutAdvance } from './about/about';
export { ContactPage as ContactAdvance } from './contact/contact';



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/index.ts